import { ProviderServices } from '../../../services/chat/createProviderServices';
import { UserRole } from '../../../domain/users/models/User';

export interface LoadInitialUserDataHandlerInput {
    userId: string;
    accessToken: string;
    providerServices: ProviderServices;
}

export interface LoadInitialUserDataResult {
    pinnedAgents: string[];
    photoUrl?: string;
    role?: UserRole;
}

export const loadInitialUserDataHandler = async ({
    userId,
    accessToken,
    providerServices,
}: LoadInitialUserDataHandlerInput): Promise<LoadInitialUserDataResult> => {
    try {
        const response = await providerServices.proGPT.users.getUserByIdAsync(userId, accessToken);

        const user = response.value;

        return {
            pinnedAgents: user.pinnedAgents ?? [],
            photoUrl: user.adInfo?.photoUrl,
            role: user.role,
        };
    } catch {
        return { pinnedAgents: [] };
    }
};

export default loadInitialUserDataHandler;
